/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListContactRequestJobsQueryResponse,
  ListContactRequestJobsQueryParams,
} from '../types/ListContactRequestJobs'

function getListContactRequestJobsUrl() {
  const res = { method: 'GET', url: `/api/v1/contact_request/` as const }
  return res
}

/**
 * @summary List contact request jobs (paginated)
 * {@link /api/v1/contact_request/}
 */
export async function listContactRequestJobs(
  params?: ListContactRequestJobsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListContactRequestJobsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListContactRequestJobsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
